module.exports = __webpack_public_path__ + "img/share-logo.c9c98740.png";